import { render, staticRenderFns } from "./AfterMooring.vue?vue&type=template&id=10d0e2b8&scoped=true&"
import script from "./AfterMooring.vue?vue&type=script&lang=js&"
export * from "./AfterMooring.vue?vue&type=script&lang=js&"
import style0 from "./AfterMooring.vue?vue&type=style&index=0&id=10d0e2b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0e2b8",
  null
  
)

export default component.exports